import { CEPromo } from '@/components/blocks/PromotionCard/parts/CEPromo';
import { Combo } from '@/components/blocks/PromotionCard/parts/Combo';
import { MSIDrawer } from '@/components/blocks/PromotionCard/parts/MSIDrawer';
import { NxMPromo } from '@/components/blocks/PromotionCard/parts/NxMPromo';
import { Remate } from '@/components/blocks/PromotionCard/parts/Remate';
import { WholeSalePrice } from '@/components/blocks/PromotionCard/parts/WholesalePrice';
import { SaveMorePromo } from '@/components/blocks/SaveMore/SaveMorePromo';
import { PROMOTION_TYPES } from '@/data/constants/promoIconConstants';
import { useLocalization } from '@/data/Localization';
import { Fragment } from 'react';

export type PromotionBaseProps = {
	partNumber?: any;
	wholeSalePrice?: any;
	saveMore?: any;
	nXm?: { baseQty: number; giftQty: number };
};

export interface PromotionProps extends PromotionBaseProps {
	ContainerComponent?: React.ComponentType<{ children?: React.ReactNode }>;
	identitifier: PROMOTION_TYPES;
}

// eslint-disable-next-line complexity
export const Promotion = ({
	identitifier,
	partNumber,
	wholeSalePrice,
	saveMore,
	nXm,
	ContainerComponent = Fragment,
}: PromotionProps) => {
	switch (identitifier) {
		case PROMOTION_TYPES.PROMOICON_GR:
			return (
				<ContainerComponent>
					<Remate />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMOICON_CE:
			return (
				<ContainerComponent>
					<CEPromo />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMORIBBON_NXM_2BY1:
		case PROMOTION_TYPES.PROMORIBBON_NXM_3BY2:
		case PROMOTION_TYPES.PROMORIBBON_NXM_4BY3:
		case PROMOTION_TYPES.PROMORIBBON_NXM_5BY3:
		case PROMOTION_TYPES.PROMORIBBON_NXM_5BY4:
		case PROMOTION_TYPES.PROMORIBBON_NXM_6BY5:
		case PROMOTION_TYPES.PROMORIBBON_NXM_7BY6:
		case PROMOTION_TYPES.PROMORIBBON_NXM_8BY7:
		case PROMOTION_TYPES.PROMORIBBON_NXM_9BY8:
		case PROMOTION_TYPES.PROMORIBBON_NXM_10BY9:
		case PROMOTION_TYPES.PROMORIBBON_NXM_11BY10:
		case PROMOTION_TYPES.PROMORIBBON_NXM_12BY10:
		case PROMOTION_TYPES.PROMORIBBON_NXM_12BY11:
		case PROMOTION_TYPES.PROMORIBBON_NXM_16BY15:
			return (
				<ContainerComponent>
					<NxMPromo name={identitifier} nXm={nXm} />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMORIBBON_COMBO:
			return (
				<ContainerComponent>
					<Combo />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMORIBBON_AHP:
			return (
				<ContainerComponent>
					<WholeSalePrice wholeSalePrice={wholeSalePrice} />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMOICON_CP:
			return (
				<ContainerComponent>
					<SaveMorePromo partNumber={partNumber} saveMore={saveMore} />
				</ContainerComponent>
			);
		case PROMOTION_TYPES.PROMOICON_MSI:
			return (
				<ContainerComponent>
					<MSIDrawer />
				</ContainerComponent>
			);

		// Not implemented
		case PROMOTION_TYPES.PROMORIBBON_NXM_:
		case PROMOTION_TYPES.PROMOICON_VF:
		case PROMOTION_TYPES.PROMOICON_PC:
		case PROMOTION_TYPES.ONLINE_ONLY_SELLING_STORE:
		case PROMOTION_TYPES.PROMOICON_NLP:
		case PROMOTION_TYPES.PROMOICON_FP:
		case PROMOTION_TYPES.PROMOICON_FP_REWARD:
			return null;

		default: {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const _exhaustiveCheck: never = identitifier;
			return null;
		}
	}
};

interface TitleMap {
	[key: string]: string;
}

export const useTitleMap = (variant: string): string => {
	const { Labels: piLabel } = useLocalization('PaymentInstructions');
	const { OrderComplete } = useLocalization('OrderConfirmation');
	const { Labels: promoLabel } = useLocalization('Promotions');
	const { ChooseDeliveryzoneCheckout } = useLocalization('DeliveryZone');

	const mapping: TitleMap = {
		// TODO: add to translation file
		menu: 'Menú',
		stores: 'Elige una tienda',
		cart: 'Productos en mi carrito',
		facet: 'Filtrar y ordenar',
		'especificaciones-tecnicas': 'Especificaciones Técnicas',
		disponibilidad: 'Buscar disponibilidad',
		msi: 'Meses sin intereses',
		delivery: 'Zona de entrega',
		bopis: 'Tienda de entrega',
		'informacion-adicional': 'Información adicional',
		order: 'Continúa con tu orden',
		instalation: 'Especificaciones de instalación',
		promotions: promoLabel.Title.t(),
		'payment-instructions': piLabel.Title.t(),
		'instructions-oxxo': OrderComplete.Oxxo.DrawerTitle.t(),
		'seguimiento-entrega': 'Seguimiento de entrega',
		'checkout-profiles': 'Compra rápida',
		'mini-sign-in': 'Continúa con tu orden',
		'super-sku': 'Selecciona tus opciones',
		'kit-specifications': 'Especificaciones',
		'wishList-drawer': 'Crear nueva lista',
		'buy-by-color': 'Comprar por color',
		giftProduct: 'Con regalo',
		saveMore: 'Ahorra más',
		checkout: ChooseDeliveryzoneCheckout.Title.t(),
	};

	return mapping[variant];
};
